// from Stackoverflow: https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
const shuffleArray = (array) => {
    let currentIdx = array.length;
    let randomIdx;

    while (currentIdx !== 0) {
        randomIdx = Math.floor(Math.random() * currentIdx);
        currentIdx--;

        [array[currentIdx], array[randomIdx]] = [
            array[randomIdx], array[currentIdx]];
    }

    return array;
};

const removeAllChildNodes = (parent) => {
    if (parent.hasChildNodes()) {
        while(parent.firstChild) {
            parent.removeChild(parent.firstChild);
        }
    }
};

// https://stackoverflow.com/questions/1186414/whats-the-algorithm-to-calculate-aspect-ratio
const gcd = (a, b) => b === 0 ? a : gcd(b, a%b);

const getAspectRatio = (w, h) => {
    const denom = gcd(w,h);
    return [w/denom, h/denom];
};

// assumes non negative numbers
const getLargestNum = (nums) => nums.reduce((largest, current) => current > largest ? current : largest, 0);

const arraysEqual = (arr1, arr2) => arr1.length === arr2.length && arr1.every((val, idx) => val === arr2[idx]);

export { shuffleArray, removeAllChildNodes, gcd, getAspectRatio, getLargestNum, arraysEqual };
